import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { BehaviorSubject } from 'rxjs';
import { isNullOrUndefined } from '../../shared';
import { AppStateService } from '../../../services/app-state.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  userInfo: any;
  loggedIn: boolean = false;
  token: string = "null";
  authState = new BehaviorSubject<boolean>(this.loggedIn);

  constructor(private keycloakSrv : KeycloakService,private appState:AppStateService) {
    const userInfoStr = localStorage.getItem('userInfo');
    const token = this.appState.getToken() ? this.appState.getToken() : null;
    const userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;
    this.setUserInfo(userInfo, (token as string));
  }

  setUserInfo(userInfo: any, token: string) {
    this.userInfo = userInfo;
    this.token = token;
    
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
    // localStorage.setItem('token', this.token);
    this.appState.setToken(this.token);
    
    this.loggedIn = !!userInfo && !!userInfo.userId ;
    this.authState.next(this.loggedIn);
    if(this.loggedIn){
      this.setKeycloakInstance();
    }
    let isRefreshTokenPresent = localStorage.getItem('refreshToken');

    if (this.loggedIn && isNullOrUndefined(isRefreshTokenPresent)) {
      let refreshToken: any = this.keycloakSrv.getKeycloakInstance() && this.keycloakSrv.getKeycloakInstance().refreshToken? this.keycloakSrv.getKeycloakInstance().refreshToken: null;
      localStorage.setItem('refreshToken', refreshToken);
    }
  }

   setKeycloakInstance(){
      const keyCloakAuth = this.appState.getKeyCloakInstance()
        ? this.appState.getKeyCloakInstance()
        : this.keycloakSrv.getKeycloakInstance();

      if (isNullOrUndefined(this.appState.getKeyCloakInstance())) {
        this.appState.setKeyCloakInstance(keyCloakAuth);
    }
  }

  isLoggedIn(): boolean {
    return !!this.loggedIn;
  }
  setManualLogin(){
    this.loggedIn = true
  }
  getManualLogin(){
    return this.loggedIn
  }
  isPromptToChangePswd ():boolean{
    return this.loggedIn ? this.userInfo.promptForChangePassword : false
  }

  getUserId(): string | null {
    return this.loggedIn ? this.userInfo?.userId : null;
  }

  getToken(): string | null {
    return this.loggedIn ? this.appState.getToken() : null;
  }

  async getAccessToken(): Promise<string | null> {
    return this.getToken() ?? await this.keycloakSrv.getToken();
  }

  getRefreshToken() : string | null {
    return this.loggedIn ? localStorage.getItem('refreshToken') : null;
  }

  getUserName(){
    return this.loggedIn ? this.userInfo.username : null;
  }

  handleError(error: any){
    if(error.status == 0){
      return 'Server Unreachable';
    }
    else if(error.status == 401){
      return 'Incorrect login credentials i.e. user or password!'
    }
    else if(error. status == 403){
      return 'Forbidden'
    }
    else if(error.status == 404){
      return 'Not Found'
    }
    else if(error.status == 500){
      return 'Internal Server Error'
    }
    return 'Error while API call'
  }
}

